import slice from "./dataSlice";

export default slice.reducer;
